import { Action } from 'redux';
export const GET_SYSTEM_ALERT_DRIVER_CONTENTS = 'driver-home-page/GET_SYSTEM_ALERT_DRIVER_CONTENTS';
export const SET_SYSTEM_ALERT_DRIVER_CONTENTS = 'driver-home-page/SET_SYSTEM_ALERT_DRIVER_CONTENTS';
export const PERSIST_SYSTEM_DRIVER_ALERT = 'driver-home-page/PERSIST_SYSTEM_DRIVER_ALERT';
export const UPDATE_SUPER_ADMIN_DRIVER_ALERT = 'driver-home-page/UPDATE_SUPER_ADMIN_DRIVER_ALERT';
/**
 * Get home page contents
 */
export interface GetSystemAlertContentsActionDriver extends Action<typeof SET_SYSTEM_ALERT_DRIVER_CONTENTS> {
  payload: any;
}

export const getSystemAlertDriverContents = () => ({
  type: GET_SYSTEM_ALERT_DRIVER_CONTENTS,
});

export const setSystemAlertDriverContents = (data: any): GetSystemAlertContentsActionDriver => ({
  type: SET_SYSTEM_ALERT_DRIVER_CONTENTS,
  payload: data,
});

export const persistSystemDriverAlert = (data: any) => ({
  type: PERSIST_SYSTEM_DRIVER_ALERT,
  payload: data,
});
export const updateDriverSystemDriverAlert = (data: any) => {
  return {
    type: UPDATE_SUPER_ADMIN_DRIVER_ALERT,
    payload: data,
  };
};
